import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  declarationId: string;
  notificationId: string;
}

export const useMarkCustomsNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, notificationId }: HookProps) => {
      const result = await apiClient.declarationsCustoms.markCustomsNotificationAsRead.mutation({
        params: { declarationId, notificationId },
      });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Notification marked read.');
    },
    onError: (error) => {
      showErrorToast(error, `Error marking the notification as read!`);
    },
  });
};
